/**
 * «Повторить» on a recents row — the compact sibling of the finished order's own button.
 *
 * A link rather than a button because of where it sits: a 54px primary control inside a list row
 * would outweigh the row it belongs to, and this is a shortcut, not the screen's main action.
 *
 * Failures are shown in place, on the control itself. A banner pushed into the home screen for a
 * shortcut that did not work would rearrange the page around a convenience.
 *
 * Вопрос перед затиранием незавершённой заявки — общий с кнопкой на завершённом заказе, см.
 * `useRepeatOrder`. Здесь он нужнее всего: эта ссылка стоит на главной в двух сантиметрах от
 * карточки «У вас есть незавершённая заявка», и промахнуться по ней проще всего.
 */
import { prepareRepeatDraftById } from '@/features/order/prepareRepeat';
import { useRepeatOrder } from '@/features/order/useRepeatOrder';

export function RepeatOrderLink({ orderId }: { orderId: string }) {
  const repeat = useRepeatOrder(() => prepareRepeatDraftById(orderId));

  return (
    <>
      <button
        type="button"
        disabled={repeat.isPending}
        onClick={repeat.start}
        className="shrink-0 rounded-sm px-2 py-1.5 text-[13px] font-bold text-accent disabled:opacity-55"
      >
        {repeat.isPending ? 'Готовим…' : repeat.isError ? 'Ещё раз' : 'Повторить'}
      </button>
      {repeat.confirmation}
    </>
  );
}
